var classes = {
  hidden: 'tw-hidden',
  invisible: 'tw-invisible'
};
export function renderMedia(productMedia, variant, media) {
  if (!productMedia || productMedia.length === 0) {
    return;
  }

  if (!variant) {
    return;
  }

  var index = 0;

  if (variant.featured_media) {
    index = variant.featured_media.position - 1;
  }

  var targetSlide = media[index];
  targetSlide.classList.remove(classes.invisible);
  productMedia.slideTo(index);
}
export function renderPrice(productPrices, productPrice, variant) {
  var productPriceEl = productPrice;

  if (variant) {
    productPriceEl.innerHTML = Avatar.theme.Currency.formatMoney(variant.price);
  } else {
    productPriceEl.innerHTML = Avatar.theme.i18n.unavailable;
  }
}
export function renderComparePrice(productComparePrice, variant) {
  if (!productComparePrice) return;
  var productComparePriceEl = productComparePrice;

  if (!variant) {
    productComparePriceEl.textContent = '';
    return;
  }

  if (variant.compare_at_price > variant.price) {
    // eslint-disable-next-line max-len
    productComparePriceEl.innerHTML = Avatar.theme.Currency.formatMoney(variant.compare_at_price);
    productComparePrice.classList.remove(classes.hidden);
  } else {
    productComparePriceEl.textContent = '';
    productComparePrice.classList.add(classes.hidden);
  }
}
export function renderUnitPrice(unitPrice, baseUnit, variant) {
  if (!variant || !unitPrice) return;
  if (!variant.unit_price_measurement) return;
  var unitPriceEl = unitPrice;
  var baseUnitEl = baseUnit;
  unitPriceEl.innerHTML = Avatar.theme.Currency.formatMoney(variant.unit_price);
  baseUnitEl.textContent = variant.unit_price_measurement.reference_value === 1 ? variant.unit_price_measurement.reference_unit : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
}
export function renderSku(sku, variant) {
  if (!sku || !variant) return;
  var skuEl = sku;
  var skuElParent = sku.parentElement; // eslint-disable-next-line no-unused-expressions

  variant.sku ? skuElParent.classList.remove(classes.hidden) : skuElParent.classList.add(classes.hidden);
  skuEl.textContent = variant.sku;
}
export function renderButton(productButtonText, variant) {
  var productButton = productButtonText.parentElement;
  var icon = productButton.querySelector('.icon');
  var productButtonTextEl = productButtonText;

  if (!variant) {
    productButton.setAttribute('disabled', true);
    productButtonTextEl.textContent = Avatar.theme.i18n.unavailable;
    icon && icon.classList.add(classes.hidden);
  } else if (variant.available) {
    productButton.removeAttribute('disabled');
    productButtonTextEl.textContent = Avatar.theme.i18n.addToCart;
    icon && icon.classList.remove(classes.hidden);
  } else {
    productButton.setAttribute('disabled', true);
    productButtonTextEl.textContent = Avatar.theme.i18n.soldOut;
    icon && icon.classList.add(classes.hidden);
  }
}
export function updateVariant(productVariant, variant) {
  if (!variant) return; // eslint-disable-next-line no-param-reassign

  productVariant.value = variant.id;
}
export function updateBrowserHistory(variant) {
  if (!variant) return;
  var url = getUrlWithVariant(window.location.href, variant.id);
  window.history.replaceState({
    path: url
  }, '', url);
}
export function updateStoreAvailabilityContent(storeAvailability, variant) {
  if (!variant || !storeAvailability) {
    storeAvailability.clearContent();
    return;
  }

  if (variant.available) {
    storeAvailability.updateContent(variant.id);
  } else {
    storeAvailability.clearContent();
  }
}

function getUrlWithVariant(url, id) {
  if (/variant=/.test(url)) {
    return url.replace(/(variant=)[^&]+/, '$1' + id);
  } else if (/\?/.test(url)) {
    return url.concat('&variant=').concat(id);
  }

  return url.concat('?variant=').concat(id);
}